export default __webpack_public_path__ + "static/media/receivables.b82dd93b.svg";